import { render, staticRenderFns } from "./dialognoPadding2.vue?vue&type=template&id=4ca9a3ef&scoped=true&"
import script from "./dialognoPadding2.vue?vue&type=script&lang=js&"
export * from "./dialognoPadding2.vue?vue&type=script&lang=js&"
import style0 from "./dialognoPadding2.vue?vue&type=style&index=0&id=4ca9a3ef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca9a3ef",
  null
  
)

export default component.exports